export const getListOfRCSPrice = {
  GET_LIST_OF_RCS_PRICE_REQUEST: "GET_LIST_OF_RCS_PRICE_REQUEST",
  GET_LIST_OF_RCS_PRICE_SUCCESS: "GET_LIST_OF_RCS_PRICE_SUCCESS",
  GET_LIST_OF_RCS_PRICE_ERROR: "GET_LIST_OF_RCS_PRICE_ERROR"
};

export const editRCSPrice = {
  EDIT_RCS_PRICE_REQUEST: "EDIT_RCS_PRICE_REQUEST",
  EDIT_RCS_PRICE_SUCCESS: "EDIT_RCS_PRICE_SUCCESS",
  EDIT_RCS_PRICE_ERROR: "EDIT_RCS_PRICE_ERROR"
};
